class QuantityInput extends HTMLElement {
    constructor() {
      super();
      console.log("Inicializando QuantityInput");
      
      this.input = this.querySelector('input[type="number"]');
      this.plusButton = this.querySelector('button[name="plus"]');
      this.minusButton = this.querySelector('button[name="minus"]');
      
      console.log("Elementos encontrados:", {
        input: this.input,
        plusButton: this.plusButton,
        minusButton: this.minusButton
      });
      
      // Agregar event listeners
      this.plusButton.addEventListener('click', () => {
        console.log("Click en botón plus");
        this.cambiarCantidad(1);
      });
      
      this.minusButton.addEventListener('click', () => {
        console.log("Click en botón minus");
        this.cambiarCantidad(-1);
      });
    }

    cambiarCantidad(delta) {
      let valorActual = parseInt(this.input.value);
      let nuevoValor = valorActual + delta;
      
      console.log("Cambiando cantidad:", {
        valorActual: valorActual,
        delta: delta,
        nuevoValor: nuevoValor,
        valorMinimo: parseInt(this.input.min)
      });
      
      // Validar límites
      if (nuevoValor >= parseInt(this.input.min)) {
        this.input.value = nuevoValor;
        
        // Disparar eventos
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.dispatchEvent(new CustomEvent('quantity:changed', {
            bubbles: true,
            detail: { value: nuevoValor }
        }));
        
        // Actualizar estado de botones
        this.minusButton.disabled = nuevoValor <= parseInt(this.input.min);
        console.log("Estado botón minus:", this.minusButton.disabled);
      } else {
        console.log("No se actualizó el valor - está por debajo del mínimo permitido");
      }
    }
}

customElements.define('quantity-input', QuantityInput);
  